import request from '@/service/api'
import ConfigType from '@/service/api/type'
import qs from 'qs'
enum SupplierModuleApi {
    // 供应商模块 - 采购单管理
    READERPMOUDLE = '/PurchaseOrder/GetPurchase',
    DELIVERYORDERMANAGEMENT = '/PurchaseOrder/Page',
    SYSTEMDENO = '/PurchaseOrder/GenerateSystemNo',
    CREATINGSHIPORDER = '/PurchaseOrder/CreateGoodsDeliveryList',//编辑
    CORFIRMCREATE = '/PurchaseOrder/AddGoodsDelivery',    
    SECONDARYJUDGMENT = '/PurchaseOrder/CheckPurchase',   
    CREATENON = '/PurchaseOrder/AddUrgentItem',
    // 供应商模块 - 送货预约
    DELIVERYAPPOINTMENT = '/GoodsDeliveryAppointment/Page',
    CREATERANDOMDELIVERYNO = '/GoodsDeliveryAppointment/GenerateSystemNo',//自动生成预约单号
    DELIVERYNOSELECTADD = '/GoodsDeliveryAppointment/Add',
    DELIVERYNOSELECTDELETE = '/GoodsDeliveryAppointment/Delete',
    COMMITDE = '/GoodsDeliveryAppointment/Submit',
    DELIVERYSTATUS = '/GoodsDeliveryAppointment/ExamineFlowerByAppointment',
    GETPRDETAILS = '/GoodsDeliveryAppointment/DetailPage',
    PRINTORDER = '/GoodsDeliveryAppointment/Print',
    // DELIVERYGOODSLIST = '/GoodsDeliveryAppointment/Indelivery',这块是以前有个叫发货的按钮
    SHIPPINGADDRESS = "/GoodsDeliveryAppointment/GetAppointment",//发货地址
    GetAppointment = "/ManualOrderIssue/GetAppointment",//发货信息选择
   
    // 供应商模块 - 送货单管理
    GETDELIVERYSELECTDETAILSDATA = '/GoodsDelivery/page',//查询
    
    CREATINGSHIPORDERSEND = '/GoodsDelivery/CreateGoodsDeliveryList',//编辑
    CORFIRMCREATES = 'GoodsDelivery/AddGoodsDelivery',//编辑确定按钮

    DELETEDETAILSORDER = '/GoodsDelivery/delete',
    CREATEJIAJIJIANLIST = '/GoodsDelivery/CreateJiaJiJianList',//加急件列表
    // 供应商模块 - 退货管理
    // RETURNGOODSLISTDATA = '/ReturnOrder/page',
    // RETURNGOODSDETAILSLISTDATA = '/ReturnOrder/detailPage',
    // RETURNGOODSPRINT = '/ReturnOrder/print',
    // RETURNDELETE = '/ReturnOrder/delete',
    // 供应商模块 - 非标件管理
    NOMSTAMDARDLISTDATA = '/UrgentItem/Page',
    NOMSTAMDARDADDDATA = 'UrgentItem/Add',
    NOMSTAMDARDEDITDATA = '/UrgentItem/Edit',
    NOMSTAMDARDDELETEDATA = '/UrgentItem/Delete',
    // 供应商模块 - 不良明细
    RECEIVINGRESULT = '/DeliveryQualityDetails/Page',
    ADDDELIVERYQUALITY = '/DeliveryQualityDetails/Add',
    // 收货记录查询
    RECEIVE_RECORD = '/CollectManagerment/CollectPage',//已收货查询
    NOTRECEIVE_RECORD = '/CollectManagerment/NotCollectPage',//未收货查询
    PurchaseOrder_RECORD = '/PurchaseOrder/CheckPurchase',//未收货查询



}
// 读取ERP模块
export const readERP = (): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.READERPMOUDLE}`,
        method: 'get'
    })
}
// 供应商模块 - 采购单管理-列表数据
export const getDeliveryOrderManagementPage = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.DELIVERYORDERMANAGEMENT}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 供应商模块 - 采购单管理 - 新建送货单时获取系统生成送货单号
export const systemDeNo = (): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.SYSTEMDENO}`,
        method: 'get'
    })
}
// 供应商模块 - 采购单管理-新建送货单抽屉内部列表数据
export const getCreatingShipOrderPage = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.CREATINGSHIPORDER}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 供应商模块 - 采购单管理 - 新建送货单抽屉内生成送货单
export const createDeliOrder = (data: any): ConfigType<any> => {
    return request({
        url: SupplierModuleApi.CORFIRMCREATE,
        method: 'post',
        data
    })
}

// 供应商模块 - 采购单管理 - 新建送货单时判断是否撤销
export const secondJundgment = (data: any): ConfigType<any> => {
    return request({
        url: SupplierModuleApi.SECONDARYJUDGMENT,
        method: 'post',
        data
    })
}
// 供应商模块 - 采购单管理 - 新建加急件
export const createNonstandad = (data: any): ConfigType<any> => {
    return request({
        url: SupplierModuleApi.CREATENON,
        method: 'post',
        data
    })
}
//--------------------------------------------------------------------------------
// 供应商模块 - 送货预约-列表数据
export const getDeliveryAppointment = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.DELIVERYAPPOINTMENT}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 供应商模块 - 送货预约 - 随机生成预约单号
export const createRanDelivery = () => {
    return request({
        url: `${SupplierModuleApi.CREATERANDOMDELIVERYNO}`,
        method: 'get'
    })
}

// 供应商模块 - 送货预约 - 新增
export const addDeliveryNoList = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.DELIVERYNOSELECTADD}`,
        method: 'post',
        data
    })
}
// 供应商模块 - 送货预约 - 提交
export const commitDelivery = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.COMMITDE}`,
        method: 'post',
        data
    })
}
// 供应商模块 - 送货预约 - 删除
export const deteleDeliveryNoList = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.DELIVERYNOSELECTDELETE}`,
        method: 'post',
        data
    })
}


// 供应商模块 - 发货按钮
// export const deliveryGoodsList = (data: any): ConfigType<any> => {
//     return request({
//         url: `${SupplierModuleApi.DELIVERYGOODSLIST}`,
//         method: 'post',
//         data
//     })
// }
// 送货预约 - 获取编辑中所有的下拉框
export const getShipAddress = () => {
    return request({
        url: `${SupplierModuleApi.SHIPPINGADDRESS}`,
        method: 'get'
    })
}
export const getAppointment = () => {
    return request({
        url: `${SupplierModuleApi.GetAppointment}`,
        method: 'get'
    })
}
// 送货预约点击状态查看整体进度接口
export const getDeliveryStatusApi = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.DELIVERYSTATUS}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 供应商模块 - 送货单预约-打印送货单
export const getOrderData = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.PRINTORDER}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 物料标签打印前
// export const WareMaterialTag = (data: any): ConfigType<any> => {
//     return request({
//         url: `${SupplierModuleApi.WAREMATERING}`,
//         method: 'post',
//         data
//     })
// }
//-----------------------------------------------------------------------------------------------
// 供应商模块 - 送货单管理 - 送货单列表
export const getDeliveryDetailsData = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.GETDELIVERYSELECTDETAILSDATA}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 供应商模块 - 送货单详情
export const getPrDetails = (data: any) => {
    return request({
        url: `${SupplierModuleApi.GETPRDETAILS}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 供应商模块 - 送货单管理-新建送货单抽屉内部列表数据
export const getSendShipOrderPage = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.CREATINGSHIPORDERSEND}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 供应商模块 - 送货单管理-编辑确定按钮
export const createDeliOrders = (data: any): ConfigType<any> => {
    return request({
        url: SupplierModuleApi.CORFIRMCREATES,
        method: 'post',
        data
    })
}
// 供应商模块 - 送货单管理-加急件送货单抽屉内部列表数据
export const CreateJiaJiJianList = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.CREATEJIAJIJIANLIST}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 供应商模块 - 送货单管理 - 删除送货单详情
export const deleteJundgment = (data: any): ConfigType<any> => {
    return request({
        url: SupplierModuleApi.DELETEDETAILSORDER,
        method: 'post',
        data
    })
}
//------------------------------------------------------------------------------------------------

// 供应商模块 - 退货管理
// export const returnGoodsList = (data: any): ConfigType<any> => {
//     return request({
//         url: `${SupplierModuleApi.RETURNGOODSLISTDATA}`,
//         method: 'get',
//         params: data
//     })
// }
// // 供应商模块 - 退货单详情列表
// export const returnGoodsDetailsList = (data: any): ConfigType<any> => {
//     return request({
//         url: `${SupplierModuleApi.RETURNGOODSDETAILSLISTDATA}`,
//         method: 'get',
//         params: data
//     })
// }
// // 供应商模块 - 退货单详情打印获取数据接口
// export const returnGoodsPrint = (data: any): ConfigType<any> => {
//     return request({
//         url: SupplierModuleApi.RETURNGOODSPRINT,
//         method: 'get',
//         params: data
//     })
// }
// // 供应商模块 - 退货单删除数据接口
// export const returndelete = (data: any): ConfigType<any> => {
//     return request({
//         url: SupplierModuleApi.RETURNDELETE,
//         method: 'post',
//         data
//     })
// }
//------------------------------------------------------------------------------------------------
// 供应商模块 - 加急件管理
export const nonstandardList = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.NOMSTAMDARDLISTDATA}`,
        method: 'get',
        params: data
    })
}
export const nonstandardAdd = (data: any): ConfigType<any> => {
    return request({
        url: SupplierModuleApi.NOMSTAMDARDADDDATA,
        method: 'post',
        data
    })
}
export const nonstandardEdit = (data: any): ConfigType<any> => {
    return request({
        url: SupplierModuleApi.NOMSTAMDARDEDITDATA,
        method: 'post',
        data
    })
}
//删除
export const nonstandardDelete = (data: any): ConfigType<any> => {
    return request({
        url: SupplierModuleApi.NOMSTAMDARDDELETEDATA,
        method: 'post',
        data
    })
}
//供应商管理-收货结果
export const receiving = (data: any): ConfigType<any> => {
    return request({
        url: `${SupplierModuleApi.RECEIVINGRESULT}`,
        method: 'get',
        params: data
    })
}

// 供应商模块 - 不良明细 - 新建送货单
export const createdeliveryqualitydetails = (data: any): ConfigType<any> => {
    return request({
        url: SupplierModuleApi.ADDDELIVERYQUALITY,
        method: 'post',
        data
    })
}
//********************************收货记录查询*******************************//
//已收查询
export const getReceiveRecord = (data: any): ConfigType<any> => {
    return request({
      url: `${SupplierModuleApi.RECEIVE_RECORD}?${qs.stringify(data)}`,
      method: 'get'
    })
}
//未收查询
export const getUnreceiveRecord = (data: any): ConfigType<any> => {
    return request({
      url: `${SupplierModuleApi.NOTRECEIVE_RECORD}?${qs.stringify(data)}`,
      method: 'get'
    })
}

//未收查询
export const PurchaseOrderdetails = (data: any): ConfigType<any> => {
    return request({
        url: SupplierModuleApi.PurchaseOrder_RECORD,
        method: 'post',
        data
    })
}

